import { yupResolver } from "@hookform/resolvers/yup";
import Button from "../../components/button";
import Modal from "../../components/modal";
import { FormInput } from "../../wrappers/formInput";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { DropDownInput } from "../../wrappers/selectInput";
import RangeSelector from "../../components/rangeSlider";
import { MultiDropDownInput } from "../../wrappers/multiselectInput";
import * as CONSTANTS from "../../utils/CONSTANTS";
import Checkbox from "../../components/checkbox";
import DatepickerDefault from "../../components/daterangePicker";
import { getMilliSecUTC, skillNameConverter } from "../../utils/EllowUtils";
import Styles from "./styles.module.scss";

export type ResourcesFilterFormFields = {
  core_skills: string;
  otherSkills: string;
  billingType: string;
  currencyType: string;
  minimumBudget: string;
  maximumBudget: string;
  location: string;
  allocatedTo: string;
  job_role: string;
  availability: string;
  job_type: string;
  sourcedBy: string;
  experience: any;
  position_status: any;
  contractStatus: any;
  dateWithin: any;
  candidateWorkType: string;
  coreSkillsCombination: any;
  positionStatusCombination: any;
  behalf_of: any;
  customerName: string;
};

interface Props {
  ClickHandler?: any;
  onClose?: any;
  defaultValues?: any;
  jobId?: any;
  allocatedTo?: any;
  behalf_of?: any
  getProviderResources?: any;
  getRecruiterResources?: any;
  companyList?: [{ companyName: string; companyId: string }];
  skillsList: any;
  jobRolesList: any;
}



const ResourceFilter: React.FC<Props> = ({
  ClickHandler,
  onClose,
  defaultValues,
  allocatedTo,
  behalf_of,
  getProviderResources,
  getRecruiterResources,
  companyList,
  skillsList,
  jobRolesList
}) => {

  const validationSchema = Yup.object({
    billingType: Yup.string().when(
      'minimumBudget', {
        is: (billingType: any) => {
          if (billingType !== '') {
            return billingType
          }
        },
        then: Yup.string().required('Provide billing type')
    }
    ),
    currencyType: Yup.string().when(
      'minimumBudget', {
        is: (currencyType: any) => {
          if (currencyType !== '') {
            return currencyType
          }
        },
        then: Yup.string().required('Provide currency type')
    }
    )
  });

 


  const formOptions = {
    resolver: yupResolver(validationSchema),
  };

  const {
    register,
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
    watch
  } = useForm<ResourcesFilterFormFields>(formOptions);


  const [range, setRange] = useState<{ from?: number; to?: number }>({
    from: 0,
    to: 20,
  });
  let positionvalue: any = [];
  let resourcevalue: any = [];
  
  const [dropDownData, setDropDownData] = useState([]);
  const [disable, setDisable] = useState<boolean>(true);
  const skillvalues = skillsList && skillsList.length > 0 && skillNameConverter(skillsList) && skillNameConverter(skillsList).length > 0 && skillNameConverter(skillsList).map((item: any) => item.skillName);

  useEffect(() => {
    
    if (defaultValues) {
   
      if (defaultValues.rates) {
        defaultValues.minimumBudget = defaultValues.rates.from
        defaultValues.maximumBudget = defaultValues.rates.to
      }
      if (defaultValues.skills) {
        defaultValues.core_skills = defaultValues.skills
      }
      reset(defaultValues)
      if (defaultValues.experience) {
        setValue("experience", defaultValues.experience);
        // defaultValues.experience = {
        //   min: defaultValues.experience.from,
        //   max: defaultValues.experience.to
        // }
        setRange(defaultValues.experience);
      }
    }
    if(behalf_of){
      setDisable(false)
      setValue('behalf_of',behalf_of)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues]);

  useEffect(() => {
    
    sourcedByType(watch())
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch().sourcedBy]);


  const sourcedByType = (data: any) => {
    
    if (data.sourcedBy !== undefined) {
      if (data.sourcedBy === "Candidate") {
        setValue('behalf_of','')
        setDisable(true)
      }
      if (data.sourcedBy === "Provider") {
        getProviderResources().then((response: any) => {
          if (response.status === 1) { 
            setDisable(false)      
            setDropDownData(response.data)
          }
        })
      }
      if (data.sourcedBy === "Recruiter" ) {
        getRecruiterResources().then((response: any) => {
          if (response.status === 1) { 
            setDisable(false)      
            setDropDownData(response.data)
          }
        })
      }
    }
  }
  
  const onclose = () => {
    onClose();
  };

  const onSubmit = (data: any) => {   
    
    if(data.behalf_of === ''){
      delete data.behalf_of
    }  
    if (data.positionStatus) {
      if (data.positionStatus.length > 0) {
        ClickHandler(data);
      }
      else {
        delete data.positionStatus
      }
    }
    else if (data.customerName) {
        if (data.customerName.length > 0) {
          ClickHandler(data)
        }
        else {
          delete data.customerName
      //    ClickHandler(data)
        }
      }
   else if (data.resourceStatus) {
      if (data.resourceStatus.length > 0) {
        ClickHandler(data);
      }
      else {
        delete data.resourceStatus
      }
    }
    else if (data.coreSkills) {
      if (data.coreSkills.length > 0) {
        ClickHandler(data)
      }
      else {
        delete data.coreSkills
      }
    }
    else if (data.otherSkills) {
      if (data.otherSkills.length > 0) {
        ClickHandler(data)
      }
      else {
        delete data.otherSkills
      }
    }
    else {            
      ClickHandler(data)
    }
  }

  const rangeChange = (startValue: any, endValue: any) => {
    let range = {
      from: startValue,
      to: endValue,
    };
    setValue("experience", range);
    setRange(range);
  };

  const handleChange = (e: any, name: string) => {
    if (name === "position_status") {
      if (e.target.value) {
        if ( defaultValues && defaultValues.position_status && defaultValues.position_status !== undefined && defaultValues.position_status.length !== 0) {
          positionvalue = [...defaultValues.position_status, e.target.name];
          setValue("position_status", positionvalue);
        }
        else {
          positionvalue = [...positionvalue, e.target.name];
          setValue("position_status", positionvalue)
        }
      }
      else {
        if (defaultValues && defaultValues.position_status && defaultValues.position_status !== undefined && defaultValues.position_status.length!==0) {
          positionvalue = defaultValues.position_status;
          positionvalue = positionvalue.filter((item: any) => item !== e.target.name);
          defaultValues.position_status = positionvalue;
          setValue("position_status", positionvalue);
        } else {
          positionvalue = positionvalue.filter((item: any) => item !== e.target.name);
          setValue("position_status", positionvalue);
        }
      }
    }
    if (name === "contractStatus") {
      if (e.target.value) {
        if (
          defaultValues &&
          defaultValues.contractStatus &&
          defaultValues.contractStatus !== undefined &&
          defaultValues.contractStatus.length !== 0
        ) {
          resourcevalue = [...defaultValues.contractStatus, e.target.name];
          setValue("contractStatus", resourcevalue);
        } else {
          resourcevalue = [...resourcevalue, e.target.name];
          setValue("contractStatus", resourcevalue);
        }
      } else {
        if (
          defaultValues &&
          defaultValues.contractStatus &&
          defaultValues.contractStatus !== undefined &&
          defaultValues.contractStatus.length!==0
        ) {
          resourcevalue = defaultValues.contractStatus;
          resourcevalue = resourcevalue.filter(
            (item: any) => item !== e.target.name
          );
          defaultValues.contractStatus = resourcevalue;
          setValue("contractStatus", resourcevalue);
        } else {
          resourcevalue = resourcevalue.filter(
            (item: any) => item !== e.target.name
          )
          setValue("contractStatus", resourcevalue);
        }
      }
    }

    if (name === "dateChange") {
      let dateWithin = {
        from: getMilliSecUTC(e.target.value.start),
        to: getMilliSecUTC(e.target.value.end),
      };
      setValue("dateWithin", dateWithin);
    }
  };


  return (
    <Modal title={" "} onClose={onClose} size="medium">
      <form>
        <div className="form-group">
          <label className="lablel">Core Skills</label>
          <MultiDropDownInput<ResourcesFilterFormFields>
            name="core_skills"
            placeholder=""
            data={skillvalues}
            register={register}
            errors={errors}
            control={control}
            allowCustom={false}
          />
          <div className="half-form-wrap">
            <div className="form-group">
            <label className="lablel">Skills combination</label>
            <DropDownInput<ResourcesFilterFormFields>
              name='coreSkillsCombination'
              data={[{ name: 'AND', id: true }, { name: 'OR', id: false }]}
              register={register}
              errors={errors}
              control={control}
              dataItemKey='id'
              textField="name"
            />
            </div>
          </div>
        </div>
        <div className="form-group">
          <label className="lablel">Additional Skills</label>
          <MultiDropDownInput<ResourcesFilterFormFields>
            name="otherSkills"
            data={skillvalues}
            register={register}
            errors={errors}
            control={control}
            allowCustom={false}
          />
        </div>
        <div className="form-group">
          <MultiDropDownInput<ResourcesFilterFormFields>
            name="customerName"
            placeholder="Select Company"
            register={register}
            data={companyList}
            label="Company"
            control={control}
            defaultValue={defaultValues && defaultValues.customerName}
            allowCustom={false}
          />
        </div>
        <h4>ellow rate</h4>
        {/* <div className="half-form-wrap"> 
          <div className="form-group">
            <label className="lablel">Billing Type</label>
            <DropDownInput<ResourcesFilterFormFields>
              name="billingType"
              data={CONSTANTS.billingType}
              register={register}
              errors={errors}
              control={control}
            />
          </div>
          <div className="form-group">
            <label className="lablel">Currency</label>
            <DropDownInput<ResourcesFilterFormFields>
              name="currencyType"
              data={CONSTANTS.currency}
              register={register}
              errors={errors}
              control={control}
            />
          </div>
          <div className="form-group">
            <label className="lablel">Minimum Budget</label>
            <FormInput<ResourcesFilterFormFields>
              id="minimumBudget"
              type="number"
              name="minimumBudget"
              placeholder="Minimum"
              register={register}
              errors={errors}
            />
          </div>
          <div className="form-group">
            <label className="lablel">Maximum Budget</label>
            <FormInput<ResourcesFilterFormFields>
              id="maximumBudget"
              type="number"
              name="maximumBudget"
              placeholder="Maximum"
              register={register}
              errors={errors}
              disabled={!(watch().minimumBudget) || watch().minimumBudget === ''}
            />
          </div>
        </div> */}
        {/* <h4>resource rate</h4> */}
        <div className="half-form-wrap"> 
          <div className="form-group">
            <label className="lablel"> </label>
            <DropDownInput<ResourcesFilterFormFields>
              name="billingType"
              data={CONSTANTS.billingType}
              register={register}
              errors={errors}
              control={control}
              defaultItem={'Billing type'}
            />
          </div>
          <div className="form-group">
            <label className="lablel"> </label>
            <DropDownInput<ResourcesFilterFormFields>
              name="currencyType"
              data={CONSTANTS.currency}
              register={register}
              errors={errors}
              control={control}
              defaultItem={'Currency type'}
            />
          </div>
          <div className="form-group">
            <label className="lablel"> </label>
            <FormInput<ResourcesFilterFormFields>
              id="minimumBudget"
              type="number"
              name="minimumBudget"
              placeholder="Minimum pay"
              register={register}
              errors={errors}
            />
          </div>
          <div className="form-group">
            <label className="lablel"> </label>
            <FormInput<ResourcesFilterFormFields>
              id="maximumBudget"
              type="number"
              name="maximumBudget"
              placeholder="Maximum pay"
              register={register}
              errors={errors}
              disabled={!(watch().minimumBudget) || watch().minimumBudget === ''}
            />
          </div>
        </div>
        <div className="half-form-wrap mb-0">
          <div className="form-group">
            <label className="lablel">
              Experience range &nbsp;
              <strong>
                {range.from} - {range.to} Years
              </strong>{" "}
            </label>
            <RangeSelector
              defaultValue={defaultValues && defaultValues.experience}
              onChange={(e: any) =>
                rangeChange(Math.floor(e.value.start), Math.floor(e.value.end))
              }
            />
          </div>
          {/* <div className="form-group">
            <label className="lablel">Location</label>
            <DropDownInput<ResourcesFilterFormFields>
              name="location"
              data={["", ""]}
              register={register}
              errors={errors}
              control={control}
            />
          </div> */}
        </div>
        <div className="half-form-wrap mb-0">
          <div className="form-group">
            <label className="lablel">Allocated To</label>
            <DropDownInput<ResourcesFilterFormFields>
              name="allocatedTo"
              data={allocatedTo}
              register={register}
              errors={errors}
              control={control}
            />
          </div>
          <div className="form-group">
            <label className="lablel">Job Role </label>
            <DropDownInput<ResourcesFilterFormFields>
              name="job_role"
              data={jobRolesList && jobRolesList.length > 0 && jobRolesList.map((item: any) =>item.name)}
              register={register}
              errors={errors}
              control={control}
            />
          </div>
        </div>
        <div className="half-form-wrap mb-0">
          <div className="form-group">
            <label className="lablel">Availability</label>
            <DropDownInput<ResourcesFilterFormFields>
              name="availability"
              data={CONSTANTS.localizedData}
              register={register}
              errors={errors}
              control={control}
              textField='text'
              dataItemKey='value'
            />
          </div>
          <div className="form-group">
            <label className="lablel">Job Type </label>
            <DropDownInput<ResourcesFilterFormFields>
              name="job_type"
              data={CONSTANTS.typeOfJob}
              register={register}
              errors={errors}
              control={control}
            />
          </div>
        </div>
        <div className="four-form-wrap mb-0">
          <div className="half-form-wrap">
          <div className="form-group">
            <label className="lablel">Sourced by</label>
            <DropDownInput<ResourcesFilterFormFields>
              name="sourcedBy"
              data={["Candidate", "Recruiter", "Provider"]}
              register={register}
              errors={errors}
              control={control}
            />
          </div>
          <div className="form-group">
            <label className="lablel">Source name</label>
            <DropDownInput<ResourcesFilterFormFields>
              name="behalf_of"
              data={dropDownData}
              control={control}
              disabled={disable}
              register={register}
              // errors={formState.errors}
              dataItemKey={'id'}
              textField={'name'}
            />
          </div>
          </div>
            <div className="form-group ">
              {/* <label className="lablel">Date Within</label> */}
              <DatepickerDefault
                onChange={(e: any) => handleChange(e, "dateChange")}  
              />
            </div>

        </div>
        <div className="half-form-wrap mb-0">
          <div className="form-group">
            <label className="lablel">Candidate Work Type</label>
            <DropDownInput<ResourcesFilterFormFields>
              name="candidateWorkType"
              data={CONSTANTS.candidateWorkType}
              register={register}
              errors={errors}
              control={control}
            />
          </div>
        </div>
        <div className="form-group">
          <h4>Position Status</h4>
          <div className={Styles.positionStatusList}>
            {CONSTANTS.positionStatus &&
              CONSTANTS.positionStatus.map((item: string, key: number) => {
                return (
                  <div className={Styles.positionItem}>
                    <Checkbox
                      name={item}
                      label={item}
                      onchange={(e: any) => handleChange(e, "position_status")}
                      key={key}
                      defaultChecked={
                        defaultValues &&
                        defaultValues.position_status &&
                        defaultValues.position_status.includes(item)
                      }
                    />
                  </div>
                );
              })}
          </div>
        </div>
        <div className="half-form-wrap">
          <div className="form-group">
          <label className="lablel">Position Status combination</label>
          <DropDownInput<ResourcesFilterFormFields>
            name='positionStatusCombination'
            data={[{ name: 'AND', id: true }, { name: 'OR', id: false }]}
            register={register}
            errors={errors}
            control={control}
            dataItemKey='id'
            textField="name"
          />
          </div>
        </div>
        <div className="form-group">
          <h4>Incontract Status</h4>
          <div className={Styles.positionStatusList}>
            {CONSTANTS.incontractStatus &&
              CONSTANTS.incontractStatus.map((item: string, key: number) => {
                return (
                  <div className={Styles.positionItem}>
                    <Checkbox
                      name={item}
                      label={item}
                      onchange={(e: any) => handleChange(e, "contractStatus")}
                      key={key}
                      defaultChecked={
                        defaultValues &&
                        defaultValues.contractStatus &&
                        defaultValues.contractStatus.includes(item)
                      }
                    />
                  </div>
                );
              })}
          </div>
        </div>
        <div className="popupAction">
          <Button onClick={onclose} type="submit" variant="secondary" size="small"> Cancel  </Button>
          <Button onClick={handleSubmit(onSubmit)}  type="submit" variant="primary" size="small"> Apply Filters</Button>
        </div>
      </form>
    </Modal>
  )
}
export default ResourceFilter;
